var _rect, _path, _path2, _path3, _path4, _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiteraA(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Litera_A",
    "data-name": "Litera A",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#6aa5ac"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_236_",
    d: "M61.032,69.923l-1.052,17.7,10.5-6.187,1.894-14.31L66.251,61.8Z",
    transform: "translate(-15.157 -19.925)",
    fill: "#0c1859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_233_",
    d: "M88.727,129.066,86.1,115.976,68.714,105.938,66,115.955,50.11,106.779,67.556,54.82,86.833,65.953l17.678,72.225Zm-5.64-28.516L80.772,89.081c-.547-2.567-1.2-5.85-1.957-9.87-.779-4.02-1.263-5.745-1.494-7.45-.21,1.3-.673,2.294-1.326,5.219s-2.083,8.586-4.293,17Z",
    transform: "translate(-26.058 -27.634)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_232_",
    d: "M58.41,61.69,80.844,48.6l19.3,11.154L77.687,72.843Z",
    transform: "translate(-16.891 -34.504)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_231_",
    d: "M58.41,63.47,80.844,50.38l19.3,11.133L77.687,74.6Z",
    transform: "translate(-16.891 -32.538)",
    fill: "#6aa5ac"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_228_",
    transform: "translate(45.644 61.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    d: "M60.37,76.213l12.69,8.081L69.377,70.91Z",
    transform: "translate(-60.37 -70.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    d: "M61.53,76.291l9.7,5.6L68.769,72.04Z",
    transform: "translate(-59.089 -69.662)",
    fill: "#6aa5ac"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_220_",
    transform: "translate(23.189 13.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_224_",
    d: "M105.847,145.868l22.434-13.09L110.6,60.553h0l-.21-.842-.652-.379h0L90.464,48.2,68.03,61.29h0l-.61.358-.274.842h0L49.7,114.449l15.91,9.2h0l.863.484.652-.358h0l9.617-5.3,9.175,5.3,2.631,13.09,15.826,9.133h0l.652.379.821-.505ZM90.464,49.9l17.8,10.27L87.307,72.4,69.5,62.132ZM103.848,144l-14.016-8.081L87.2,122.825l-8.965-5.177h0L68.7,112.134l-2.715,10.017-14.521-8.376L68.451,63.268,86.676,73.79l14.331,58.567Z",
    transform: "translate(-49.7 -48.2)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_221_",
    d: "M68.661,70.824c-.758-4-1.115-5.829-1.347-7.492l-1.62-1.052c-.21,1.284-.652,3.409-1.284,6.313-.631,2.883-2.083,8.586-4.293,16.962l-.147.547,13.3,7.681L70.64,80.694C70.092,78.148,69.44,74.823,68.661,70.824ZM61.675,85.387c2.168-8.207,3.536-13.616,4.167-16.478.189-.863.358-1.641.505-2.357.231,1.3.526,2.82.842,4.567.779,4.02,1.431,7.345,1.957,9.891l1.978,9.87Z",
    transform: "translate(-38.357 -32.649)",
    fill: "#0c1859"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13074_",
    transform: "translate(46.523 21.146)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_13073_",
    cx: 1.452,
    cy: 0.842,
    rx: 1.452,
    ry: 0.842,
    transform: "translate(10.696 15.447)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13072_",
    d: "M70.885,58.064c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.319,2.319,0,0,1,70.885,58.064Z",
    transform: "translate(-52.36 -45.458)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_13071_",
    cx: 1.452,
    cy: 0.842,
    rx: 1.452,
    ry: 0.842,
    transform: "translate(21.408 9.26)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13070_",
    d: "M75.975,55.124c.568.337.568.863,0,1.179a2.318,2.318,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,75.975,55.124Z",
    transform: "translate(-46.739 -48.706)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13069_",
    d: "M65.795,58.064c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.319,2.319,0,0,1,65.795,58.064Z",
    transform: "translate(-57.982 -45.458)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2975_",
    cx: 1.452,
    cy: 0.842,
    rx: 1.452,
    ry: 0.842,
    transform: "translate(10.696 9.26)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2268_",
    d: "M70.885,55.124c.568.337.568.863,0,1.179a2.251,2.251,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,70.885,55.124Z",
    transform: "translate(-52.36 -48.706)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2267_",
    d: "M73.435,53.654c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,73.435,53.654Z",
    transform: "translate(-49.544 -50.329)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2198_",
    d: "M63.255,56.594c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,63.255,56.594Z",
    transform: "translate(-60.787 -47.082)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1980_",
    d: "M65.795,55.124c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,65.795,55.124Z",
    transform: "translate(-57.982 -48.706)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1926_",
    d: "M68.345,53.654c.568.337.568.863,0,1.179a2.189,2.189,0,0,1-2.041,0c-.568-.337-.568-.863,0-1.179A2.318,2.318,0,0,1,68.345,53.654Z",
    transform: "translate(-55.166 -50.329)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_50_",
    cx: 1.452,
    cy: 0.842,
    rx: 1.452,
    ry: 0.842,
    transform: "translate(16.062)",
    fill: "#0c1859"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteraA);
export default __webpack_public_path__ + "static/media/Litera A.28503d083f735cf016013dc0a1980cb4.svg";
export { ForwardRef as ReactComponent };